import React, { useState } from 'react';

import { Box, Card } from '@mui/material';

import { paths } from 'src/routes/paths';
import { useRouter } from 'src/routes/hooks';

import { useTranslate } from 'src/locales';

import { LoadingScreen } from 'src/components/loading-screen';

import { ChannelForm } from './ChannelForm';
import { useChannelContext } from '../hooks';
import { useChannelSubmit } from '../hooks/useChannelSubmit';
import QRCodeDisplay from '../channels/Line/components/qrcode-display';
import { useConnectFb } from '../channels/Messenger/hooks/useConnectFb';
import { CopyScriptPage } from '../channels/Livechat/components/CopyScriptPage';
import { useConnectInstagram } from '../channels/Instagram/hooks/useConnectInsta';
import { useMicroSoftAuthPopup } from '../channels/Email/hooks/useMicroSoftAuthPopup';

function ChannelFormHandler({ selectedChannel, isLoading }: any) {
  const {
    state: channelState,
    handleGoogleDetail,
    handleMicrosoftDetail,
    handleFaceBookDeteail,
    setField,
  } = useChannelContext();

  React.useEffect(() => {
    // WHAT & WHY: Synchronize channelState.channelType and emailProviderType with selectedChannel details
    // so that wizard state stored in localStorage (e.g., INSTAGRAM) cannot leak into edit view of another channel type (e.g., WHATSAPP).
    if (selectedChannel?.channelType && channelState.channelType !== selectedChannel.channelType) {
      setField('channelType', selectedChannel.channelType);
    }

    const provider = selectedChannel?.config?.settings?.provider;
    if (provider === 'microsoft' || provider === 'google') {
      if (channelState.emailProviderType !== provider) {
        setField('emailProviderType', provider);
      }
    }
  }, [selectedChannel, channelState.channelType, channelState.emailProviderType, setField]);

  const [FacebookDetail, setFacebookDetail] = useState({});
  const { t } = useTranslate('translation');
  const router = useRouter();

  const { connect: connectMessenger, messengerToken } = useConnectFb({
    onSuccess: handleFaceBookDeteail,
  });

  const { connect: connectInstagram, instagramToken } = useConnectInstagram({
    onSuccess: handleFaceBookDeteail,
  });

  // Activate Microsoft Auth Redirect Listener
  useMicroSoftAuthPopup();

  const { onSubmit, isUpdateChannelLoading, redirectToScriptPage, redirectToQrPage, liveChatData } =
    useChannelSubmit(selectedChannel, channelState, FacebookDetail, instagramToken, messengerToken);

  const redirectToRoot = () => {
    router.push(paths.channel.root);
  };

  const handleSubmit = async (data: any) => {
    await onSubmit(data);

    handleGoogleDetail('');
    handleMicrosoftDetail('');
    handleFaceBookDeteail('');

    if (selectedChannel.channelType !== 'LIVE_CHAT' && selectedChannel.channelType !== 'LINE') {
      redirectToRoot();
    }
  };

  return (
    <Card sx={{ m: { xs: 0, md: 2 }, px: { xs: 1.5, md: 2 }, py: 3 }}>
      {isLoading ? (
        <Box>
          <LoadingScreen />
        </Box>
      ) : (
        <Card sx={{ height: '100%', p: { xs: 1.5, md: 3 } }}>
          {redirectToScriptPage ? (
            <CopyScriptPage
              scriptData={{
                tenantId: liveChatData?.config?.tenantId || liveChatData?.tenantId || '',
                websiteToken: liveChatData?.config?.settings?.websiteToken || '',
                welcomeTitle: liveChatData?.config?.settings?.welcomeTitle || '',
                welcomeTagline: liveChatData?.config?.settings?.welcomeTagline || '',
                widgetColor: liveChatData?.config?.settings?.widgetColor || '',
              }}
              isEdit
              redirectToRoot={redirectToRoot}
              t={t}
            />
          ) : redirectToQrPage ? (
            <QRCodeDisplay
              qrUrl={liveChatData?.config?.settings?.botInfo?.inviteLink}
              redirectToRoot={redirectToRoot}
            />
          ) : (
            <ChannelForm
              selectedChannel={selectedChannel}
              onSubmit={handleSubmit}
              isUpdateChannelLoading={isUpdateChannelLoading}
              FacebookDetail={FacebookDetail}
              setFacebookDetail={setFacebookDetail}
              connectMessenger={connectMessenger}
              connectInstagram={connectInstagram}
              onCancel={redirectToRoot}
            />
          )}
        </Card>
      )}
    </Card>
  );
}

export default ChannelFormHandler;
